import { render } from "./CommentDisplay.vue?vue&type=template&id=26207b6c"
import script from "./CommentDisplay.vue?vue&type=script&lang=js"
export * from "./CommentDisplay.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CommentDisplay.vue?vue&type=style&index=0&id=26207b6c&lang=module.css&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__